import * as React from 'react';
import {useJsonForms, withJsonFormsControlProps} from '@jsonforms/react';
import Range from '../Range/Range';
import {SchemaUtils} from "../../util/SchemaUtils";
import {ControlValueFactory} from "../../factory/ControlValueFactory";
import {Component} from "../../enum/Component";
import { ValidationUtil } from '../../util/ValidationUtil';

interface RangeControlProps {
    data: any;
    label: any;
    description?: any;
    handleChange(path: any, value: number): void;
    path: string;
    uischema: any;
    schema: any;
    errors: any;
    rootSchema: any;
}

const RangeControl = ({ errors, uischema, schema, handleChange, path, data, rootSchema }: RangeControlProps) => {

    const jsonForms = useJsonForms();

    let enabled = SchemaUtils.isComponentEnabled(uischema, jsonForms.core!.data);
    let visible = SchemaUtils.isComponentVisible(uischema, jsonForms.core!.data);
    let required = SchemaUtils.isRequired(path, rootSchema);

    let value = ControlValueFactory.getControlValue(Component.Range, data, uischema.scope, jsonForms,enabled && visible)
    value  = value === "" ? schema.minimum : value;

    const [val, setVal] = React.useState<number>(value);

    function handleRangeChange(path: string, event: any, newValue: number){
        setVal(newValue);
        handleChange(path, newValue);
    }

    if (ValidationUtil.isEmptyValue(value)) {
        errors = ""
    }

    return (
        <Range
            error={errors}
            value={val}
            required={required}
            label={uischema.label}
            description={schema.description}
            onChange={(event: any, data: number) => handleRangeChange(path, event, data)}
            minimum={schema.minimum}
            maximum={schema.maximum}
            step={schema.step}
            prefix={schema.prefix}
            suffix={schema.suffix}
            enabled={enabled}
            visible={visible}
        />
    );
};

export default withJsonFormsControlProps(RangeControl);
